import { Theme } from 'styling/theme'
import { makeStyles } from '@material-ui/styles'

export const useStyles = makeStyles((theme: Theme) => ({
    title: {
        fontFamily: theme.typographyPresets.fonts.notoSans.bold,
        fontSize: 14,
        fontStyle: 'normal',
        lineHeight: 1.43,
        letterSpacing: '0.2px',
        color: theme.colors.black,
        marginBottom: 16,
    },
    list: {
        listStyle: 'none',
        paddingLeft: 0,
    },
    form: {
        paddingBottom: 10,
    },
    disclaimer: {
        ...theme.typographyPresets.titleSmall,
        fontSize: 12,
        lineHeight: 1,
    },
}))
